import { authenticatedFetch } from '../utils/api';
import { API_HOST } from '../utils/constants';

const baseUrl = (projectId) => {
  if (projectId == null || String(projectId).trim() === '') {
    throw new Error('缺少互动剧情项目 ID');
  }
  return `${API_HOST}/api/interactive-story/projects/${encodeURIComponent(projectId)}`;
};

export const fetchInteractiveStoryState = (projectId) => (
  authenticatedFetch(baseUrl(projectId))
);

export const saveInteractiveStoryState = (projectId, state) => (
  authenticatedFetch(baseUrl(projectId), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(state || {}),
  })
);

export const getInteractiveStoryState = fetchInteractiveStoryState;
